import { Controller } from "@hotwired/stimulus";
import Request from "../utils/request";

// Replaces its own markup with a fragment fetched once the page has rendered,
// so a section backed by a slow upstream does not hold up everything else.
export default class extends Controller {
  static targets = ['status']
  static values = { url: String, error: String }

  connect() {
    Request.fetch(this.urlValue, {
      headers: {
        "Content-Type": "text/html",
        Accept: "text/html"
      }
    })
      .then(response => {
        if (!response.ok) { throw new Error(`Responded ${response.status}`) }

        return response.text()
      })
      .then(html => { this.element.innerHTML = html })
      .catch(() => {
        // The message lives in the placeholder rather than here, so the
        // markup and its wording stay with the rest of the view.
        if (this.hasStatusTarget) { this.statusTarget.textContent = this.errorValue }
      });
  }
}
